import { useSelector } from 'react-redux';
/**
 * 型定義補完が効いたuseSelectorのラッパー関数
 * @param callback
 */
export const useTypeSelector = (callback) => useSelector((state) => callback(state));
